import React from 'react';
import { Button, Header, Icon, Popup, Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

const NoPolls = () => <p><br /> Nema anketnih upitnika.</p>;

export default class StaffPollReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>

                {this.props.pollList.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Naziv anketnog upitnika</Table.HeaderCell>
                                <Table.HeaderCell colSpan={1}>Datum objave</Table.HeaderCell>
                                <Table.HeaderCell colSpan={1}>Datum isteka</Table.HeaderCell>
                                <Table.HeaderCell colSpan={1}>Izvještaji</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {this.props.pollList.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle">
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={3}>
                                        {el.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={1}>
                                        {moment(el.activationDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={1}>
                                        {moment(el.endDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>

                                        <Popup
                                            content="Struktura uzorka"
                                            position="top center"
                                            trigger={
                                                <Link to={{ pathname: '/izvještaji-ankete/struktura-uzorka', state: { id: el.id, name: el.name } }}>
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="cubes"
                                                        size="small"
                                                        color="green"
                                                        onClick={() => {
                                                            localStorage.setItem('questionnaireData', el.name + ' / ' + moment(el.activationDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.'));
                                                            localStorage.setItem('pollId', el.id);
                                                        }}
                                                    />
                                                </Link>}
                                        />

                                        {/*<Popup*/}
                                        {/*    content="Predmeti"*/}
                                        {/*    position="top center"*/}
                                        {/*    trigger={*/}
                                        {/*        // <Link to={{ pathname: '/izvještaji-ankete/predmeti', state: { id: el.id, name: el.name } }}>*/}
                                        {/*        <Button*/}
                                        {/*            disabled*/}
                                        {/*            basic="true"*/}
                                        {/*            circular*/}
                                        {/*            icon="book"*/}
                                        {/*            size="small"*/}
                                        {/*            color="teal"*/}
                                        {/*            onClick={() => {*/}
                                        {/*                localStorage.setItem('questionnaireData', el.name + ' / ' + moment(el.activationDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.'));*/}
                                        {/*            }}*/}
                                        {/*        />*/}
                                        {/*        // </Link>*/}
                                        {/*    }*/}
                                        {/*/>*/}

                                        <Popup
                                            content="Nastavno osoblje"
                                            position="top center"
                                            trigger={
                                                // <Link to={{ pathname: '/izvještaji-ankete/nastavno-osoblje', state: { id: el.id, name: el.name } }}>
                                                <Button
                                                    disabled
                                                    basic="true"
                                                    circular
                                                    icon="users"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => {
                                                        localStorage.setItem('questionnaireData', el.name + ' / ' + moment(el.activationDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.'));
                                                    }}
                                                />
                                                // </Link>
                                            }
                                        />
                                    </Table.Cell>
                                </Table.Row>))
                            }
                        </Table.Body>
                    </Table>
                    : <NoPolls />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/Reports/StaffPollReport.js